// Master Reconstruction Roadmap categories. Mirrors the 6 phases shown in
// the public-facing ReconstructionRoadmap component. Used as the single
// source of truth for the Planning event "Category" dropdown and for
// color-coding calendar bars (admin + public).
export const CATEGORIES = [
  { id: 'strategic-planning', label: 'Strategic Planning & Remediation', color: '#F59E0B' },
  { id: 'reconstruction',     label: 'Reconstruction & Tech Integration', color: '#84CC16' },
  { id: 'operational',        label: 'Operational Framework',             color: '#14B8A6' },
  { id: 'brand-experience',   label: 'Brand & Experience Prep',           color: '#3B82F6' },
  { id: 'launch-sequence',    label: 'The Launch Sequence',               color: '#8B5CF6' },
  { id: 'post-opening',       label: 'Post-Opening Optimization',         color: '#EC4899' },
];

export const CATEGORY_BY_ID = CATEGORIES.reduce((acc, c) => { acc[c.id] = c; return acc; }, {});

// Resolve a color for an event using (in order): explicit category → parent
// phase color → priority fallback.
export function colorForEvent(event, phaseById, priorityColors) {
  if (event?.kind === 'pacer' && event?.accent_color) return event.accent_color;
  if (event.category && CATEGORY_BY_ID[event.category]) return CATEGORY_BY_ID[event.category].color;
  const phase = phaseById?.[event.phase_id];
  if (phase?.color) return phase.color;
  return priorityColors?.[event.priority] || '#A3D4D4';
}
